exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.apply-for-finance-modal__title{text-align:center;color:#192a44\n}\n.apply-for-finance-modal__footer{display:grid;grid-template-columns:1fr;row-gap:15px;margin:0 auto\n}\n@media (min-width: 768px){\n.apply-for-finance-modal__footer{grid-template-columns:1fr 1fr;-webkit-column-gap:15px;-moz-column-gap:15px;column-gap:15px\n}\n}\n#selected-quote__container+.validation-error{grid-column:span 2;margin:0 auto;padding:0;text-align:center\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3e5fa53b","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/configurator/components/EnquireNowModal.vue
// module id = KV9L
// module chunks = 15